import { List, Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import api from '../../utils/api';
import { normalizeImages } from './utils/helpers';

export const initialState = Map({
  isLoading: false,
  isDetailedLoading: false,
  items: List(), // List([ContainerSummary, ...])
  detailedContainer: Map(), // Map { containerId: ContainerDetail }
});

// ── Action types ──────────────────────────────────────────────────────────────
export const GET_CONTAINERS = 'containers/GET_CONTAINERS';
export const GET_CONTAINER_DETAIL = 'containers/GET_CONTAINER_DETAIL';

// ── Action creators ───────────────────────────────────────────────────────────
export const getContainers = createAction(
  GET_CONTAINERS,
  api.containers.getContainers,
);

export const getContainerDetail = createAction(
  GET_CONTAINER_DETAIL,
  api.containers.getContainer,
);

// ── Reducer ───────────────────────────────────────────────────────────────────
const containersReducer = handleActions(
  {
    [`${GET_CONTAINERS}_REQUEST`]: (state) => state.set('isLoading', true),

    [`${GET_CONTAINERS}_SUCCESS`]: (state, { payload }) =>
      state.set('items', payload.get('data', List())).set('isLoading', false),

    [`${GET_CONTAINERS}_ERROR`]: (state) => state.set('isLoading', false),

    [`${GET_CONTAINER_DETAIL}_REQUEST`]: (state) =>
      state.set('isDetailedLoading', true),

    [`${GET_CONTAINER_DETAIL}_SUCCESS`]: (state, { payload }) => {
      const container = payload
        .get('data')
        .update('pictures', (pictures = List()) => normalizeImages(pictures))
        // items come as wrappers: [{ shipment: {...} }] — unwrap for PackagesList
        .update('items', (items = List()) =>
          items.map((item) => item.get('shipment', item)),
        );
      return state
        .setIn(['detailedContainer', container.get('id')], container)
        .set('isDetailedLoading', false);
    },

    [`${GET_CONTAINER_DETAIL}_ERROR`]: (state) =>
      state.set('isDetailedLoading', false),
  },
  initialState,
);

export default containersReducer;
